"use client";
import React, { useState, useEffect } from "react";
import { useDarkMode } from "../darkModeContext";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import data from "./constructionSteps.json";
import StepModal from "./stepModal";

export default function StepCard() {
    const { t } = useTranslation('constructionSteps');
    const isDarkMode = useDarkMode();
    const [currentStepID, setCurrentStepID] = useState("");

    useEffect(() => {
        // Dynamically import Bootstrap on the client-side only
        typeof window !== 'undefined' &&
            import('bootstrap/dist/js/bootstrap.bundle.min.js');
        }, []);

    return (
        <div className="w-full px-8 mt-4 md:px-20 xl:px-40 text-justify font-montserrat dark:bg-dark">
            <section className="mb-14 md:mb-20 grid grid-cols-1 sm:grid-cols-2 portrait-md:grid-cols-2 landscape-md:grid-cols-3 lg:grid-cols-4 gap-4">
                {data.map((item) => (
                    <div 
                        key={item.stepID} 
                        className={`card flex flex-col shadow-md cursor-pointer hover:text-blue rounded-none group ${isDarkMode ? 'bg-dark-card' : 'bg-white'}`}
                        onClick={() => setCurrentStepID(item.stepID)}
                        data-bs-toggle="modal"
                        data-bs-target={`#stepModal${item.stepID}`}>
                        <div className="relative h-[30vh] md:h-[40vh]">
                            <Image
                                src={item.imagePath[0]}
                                alt={t(`${item.stepID}.title`)}
                                layout="fill"
                                className="p-3"
                                objectFit="cover"
                            />
                        </div>
                        <div className="card-body justify-center py-0 px-3">
                            <h6 className={`card-title h-10 sm:h-14 md:h-6 px-2 hover:px-0 group-hover:font-bold duration-300 hyphens-auto text-center ${isDarkMode ? 'text-white' : 'text-black'}`}>{t(`${item.stepID}.title`)}</h6>

                            <p className="hidden md:block text-right font-montserrat mb-1 mt-8 hover:text-grow">
                                <a 
                                    className={`${isDarkMode ? 'text-dark-card' : 'text-white'} readMore location no-underline group-hover:text-blue transition-colors duration-300 font-black cursor-pointer`}
                                    data-bs-toggle="modal"
                                    data-bs-target={`#stepModal${item.stepID}`}>
                                    {'...' + t('construction.moreContent')}
                                </a>
                            </p>
                        </div>
                    </div>
                ))}
            </section>

            {data.map((item) => (
                <StepModal
                    key={item.currentStepID}
                    id={`stepModal${item.stepID}`}
                    currentStepID={currentStepID}
                    setCurrentStepID={setCurrentStepID}
                />
            ))}
        </div>
    );
}
